<template>
    <div id="app">
        <AppHeader v-if="isLoggedIn"/>

        <router-view/>
    </div>
</template>

<script>
    import AppHeader from './views/AppHeader.vue';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'App',
        computed: {
            ...mapGetters(['isLoggedIn'])
        },
        components: {
            AppHeader
        },
        created() {
            this.getBusinessLines();
            this.getClientTypes();
            this.getContractTypes();
            this.getCompanyTypes();
            this.getDivisions();
            this.default_selected_divisions();
        },
        methods: {
            ...mapActions([
                'getBusinessLines',
                'getClientTypes',
                'getContractTypes',
                'getCompanyTypes',
                'getDivisions',
                'default_selected_divisions'
            ]),
        }
    }
</script>

<style>
    *{
        box-sizing: border-box;
    }

    html{
        font-size: 62.5%;
    }

    body{
        margin: 0;
    }

    h1, h2, h3{
        margin: 0;
    }

    p{
        margin: 0;
    }

    ul{
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: 'Encode Sans',sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: #f2f2f2;
        min-height: 100vh;
        /* text-align: center; */
        /* color: #2c3e50; */
    }

    .page_body{
        flex-grow: 1;
        margin-left: 35rem;
    }
</style>
